import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b80ae1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }



export default /*#__PURE__*/_defineComponent({
  __name: 'TextLoader',
  props: {
  height: Number
},
  setup(__props) {

const props = __props
const getRandomInt = (minIn, maxIn) => {
  const min = Math.ceil(minIn)
  const max = Math.floor(maxIn)
  return Math.floor(Math.random() * (max - min + 1) + min)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRandomInt(5,10), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `rand_${item}`,
        style: _normalizeStyle({'height': `${__props.height}px`, 'width': `${getRandomInt(80,150)}px`})
      }, null, 4))
    }), 128))
  ]))
}
}

})